import { ScriptStrategy } from 'gatsby';
import { IS_BROWSER } from 'core/constants';

function injectPixel(src: string, alt: string) {
    const srcString = src.toString();

    const img = document.createElement('img');
    img.src = srcString;
    img.setAttribute('alt', alt);
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('width', '0');
    img.setAttribute('height', '0');
    img.setAttribute('style', 'display: none;');
    document.body.appendChild(img);
}

export default function renderTrackingPixel(
    src: string,
    alt: string,
    strategy: Exclude<ScriptStrategy, ScriptStrategy.offMainThread>,
): void {
    if (IS_BROWSER) {
        switch (strategy) {
            case ScriptStrategy.postHydrate:
                injectPixel(src, alt);
                break;
            case ScriptStrategy.idle:
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(() => {
                        injectPixel(src, alt);
                    });
                } else {
                    setTimeout(() => {
                        injectPixel(src, alt);
                    }, 500);
                }
                break;
            default:
                // noop
                break;
        }
    }
}
